import { Box } from "@mui/material";

export default function PictureSelector({ picturesURL, handleSelector }) {
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        borderRight: { md: "1px solid #797979" },
        marginBottom: { xs: "3px", md: "10px" },
      }}
      style={{
        height: "100%",
        flexDirection: "column",
        alignItems: "flex-end",
        marginLeft: "10px",
      }}
    >
      {picturesURL.map((item, index) => {
        return (
          <Box
            component="img"
            src={item}
            onClick={() => handleSelector(index)}
            alt="car"
            sx={{
              height: { xs: "60px", md: "100px" },
              width: { xs: "60px", md: "100px" },
              marginBottom: "5px",
              border: "2px solid #f2f2f2",
              cursor: "pointer",
            }}
          />
        );
      })}
    </Box>
  );
}